module.exports = __webpack_public_path__ + "img/Error.1bd9b569.svg";